export function sbmResposiveTables() {
    'use strict';
    $ = jQuery;
    if ($('table.tbl-responsive').length > 0) {
        const resTableTD = $('table.tbl-responsive tbody td');
        resTableTD.each(function () {
            const $td = $(this);
            const $th = $td.closest('table').find('th').eq($td.index());
            $td.attr('data-title', $th.text());
        });
    }
    const wrappedTable = $('.table-wrap table.tbl-wrap');
    if (wrappedTable.length > 0) {
        const div = $('div.table-wrap');
        $(window).on("resize", function () {
            div.each(function () {
                const thisDiv = $(this);
                const thisTable = thisDiv.find('table.tbl-wrap');
                const closestTextarea = thisDiv.closest('.mtpc-block-textarea-block');
                const currentWidth = closestTextarea.width();
                thisDiv.width(currentWidth);
                if (closestTextarea.hasClass('wide-width')) {
                    thisTable.width(1280);
                } else {
                    thisTable.width(1000);
                }
            });
        }).resize();
    }
}